import { jsx as _jsx } from "react/jsx-runtime";
import { useDragableElement } from '@core-utils/react-hooks';
import "./glowingLight.style.css";
export const GlowingLine = ({ className, id }) => {
    const { onSelect } = useDragableElement(id);
    return (_jsx("div", { className: `absolute duration-0`, onClick: onSelect, id: id, children: _jsx("div", { className: 'relative', children: _jsx("div", { className: `absolute cursor-grab z-50 top-[calc(50%-20px)] left-[50%-20px] w-4 h-16 rounded-lg bg-white glowing-line ${className}` }) }) }));
};
